export default __webpack_public_path__ + "static/media/healtheducation.c75e43a5.jpg";